import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  hint?: string;
  useAsterisks?: string;
}


export class OdsDateComponent extends React.Component<Props> {
  year;
  month;
  day;

  constructor(props: Props) {
    super(props);

    let field = this.props.field;

    FormValidationUtils.runJavascript(field);
  }
  
  setValue = () => {
    if (this.day && this.month && this.year) {
      return this.month + '/' + this.day + '/' + this.year;
    }

    return null;
  }

  onODSDateChangeOnDialog = (e, dateFormat) => {
    let field = this.props.field;
    let val = e.target.value;
    val = val.trim();

    switch (dateFormat) {
      case 'dd':
        this.day = val;
        break;
      case 'mm':
        this.month = val;
        break;
      case 'yyyy':
        this.year = val;
        break;
    }

    let finalDate = this.setValue();
    field.Value = finalDate;
    if (!Utils.isEmpty(field.Value)) {
     FormValidationUtils.validateODSDate(field);
   }

    this.props.callbackElement(this.props.field.parent.parent.parent);
  }

  onBlur=(e)=>{
    let field =  this.props.field;
    if(Utils.isEmpty(e.target.value)){
      // const dateParts = field.Value.split("/")
      // this.year=dateParts[2];
      // this.month=dateParts[0];
      // this.day=dateParts[1];  
      FormValidationUtils.validateODSDate(field);
      FormValidationUtils.runJavascript(field);
    }
   
     this.props.callbackElement(this.props.field.parent.parent.parent);
  }

  render() {
    let validateCpmpareField;
    let field = this.props.field;
    
    if(!Utils.isEmpty(field.Value)){
      const dateParts = field.Value.split("/")
      this.year=dateParts[2];
      this.month=dateParts[0];
      this.day=dateParts[1];
    }
    let displayfield: boolean = true;
    if(!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;
    let dateValid: boolean = true;


    if (field.FilterField != null) {
      let filterValue;
      let baseName;
      let bindName;
      let parts = field.FilterField.split('.');
      if (parts.length == 3) {
        baseName = parts[0] + '.' + parts[1];
        bindName = parts[2];
      }
      if (parts.length == 2) {
        baseName = parts[0];
        bindName = parts[1];
      }
      if (parts.length == 1) {
        baseName = '';
        bindName = parts[0];
      }

      let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName);

      let foundFilterField;

      if (foundFilterFields && foundFilterFields.length > 0) {
        foundFilterField = foundFilterFields[0];
      }

      if (foundFilterField != null) {
        filterValue = foundFilterField.Value;

        if (filterValue == null || filterValue != null && field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(field.FilterValue) == -1) {
          displayfield = false;
        }
      }
    }

    if (field.ValidateCompareMethod != null) {
      let subSection = field.parent as FormSubSections;
      let foundValidateCpmpareFieldList = subSection.ListOfFormSectionElements.filter(p => p.LoadBindName == field.ValidateCompareField);
      if (foundValidateCpmpareFieldList.length > 0) {
        validateCpmpareField = foundValidateCpmpareFieldList[0];
        if (field.ValidateCompareMethod == "<")
          dateValid = field.Value <= validateCpmpareField.Value;
        else if (field.ValidateCompareMethod == ">") {
          dateValid = field.Value >= validateCpmpareField.Value;
        } else {
          dateValid = field.Value == validateCpmpareField.Value;
        }
      }
    }

    if (displayfield) {
      if (field.Value == null) {
        field.Value = {}
      }
      if (editable) {
        controlArray.push(
            <fieldset role="group" className="ontario-fieldset ontario-margin-top-24-!">
              <legend className="ontario-fieldset__legend ontario-margin-bottom-0-!">
                {/* {labelControlArray} */}
                {field.Optional !== "Y" && (
                  <>
                    {title}
                    <span className="ontario-label__flag">
                      {this.props.useAsterisks=="Y" &&<span style={{color:'red'}}>*</span>}
                      {this.props.useAsterisks!=="Y" && (
                        <span className='ontario-label__flag'>{this.props.isEng? "(required)":"(obligatoire)"}</span>
                      )}
                    </span>
                  </>
                )}
                {field.Optional === "Y" && (
                  <>
                    {title}
                    <span className="ontario-label__flag">
                      {!this.props.field.ReadOnly && (this.props.isEng ?"(optional)": "(facultatif)") }
                    </span>
                    {field.enuToolTip && <i title={field.TooltipENU} className="pi pi-info-circle"/>}
                  </>
                )}
              </legend>
              {this.props.hint && <p className="ontario-hint ontario-margin-top-16-!">{this.props.hint}</p>}
              <LiveValidationErrMsg
                field={this.props.field}
                isEng={this.props.isEng}
                key={"LiveValidationErrMsg_" +field.LoadBindName}
                id={`${field.LoadBindName}-${field.Id}`}
              />

              <div className="ontario-date__group" onBlur={this.onBlur} id={field.LoadBindName}>
                <div className="ontario-date__group-input">
                  <label htmlFor="year">{this.props.isEng?"Year":"Année"}<span className="ontario-show-for-sr">(4 digits)</span></label>
                  <input
                    className={`${this.year==null || (this.year!=null && 1900< Number(this.year) && Number(this.year)<9999)? "ontario-input ontario-input--4-char-width" :"ontario-input ontario-input--4-char-width ontario-input__error"}`}
                    id="year"
                    type="text"
                    key={'fdIpt_year' + field.Id}
                    maxLength={4}
                    value={this.year}
                    aria-required={field.Optional!=="Y"}
                    aria-describedby={`${field.LoadBindName}-${field.Id}`}
                    onChange={(e) => this.onODSDateChangeOnDialog(e, "yyyy")}
                  ></input>
                </div>
                <div className="ontario-date__group-input">
                  <label htmlFor="month">{this.props.isEng?"Month":"Mois"}<span className="ontario-show-for-sr">(1 or 2 digits)</span></label>
                  <input
                    className={`${this.month==undefined || (0<this.month && this.month<13)? "ontario-input ontario-input--2-char-width": "ontario-input ontario-input--2-char-width ontario-input__error"}`}
                    id="month"
                    type="text"
                    key={'fdIpt_month' + field.Id}
                    maxLength={2}
                    max={12}
                    value={this.month}
                    aria-required={field.Optional!=="Y"}
                    aria-describedby={`${field.LoadBindName}-${field.Id}`}
                    onChange={(e) => this.onODSDateChangeOnDialog(e, "mm")}
                  ></input>
                </div>
                <div className="ontario-date__group-input">
                  <label htmlFor="day">{this.props.isEng? "Day":"Jour"}<span className="ontario-show-for-sr">(1 or 2 digits)</span></label>
                  <input
                    className={`${this.day==undefined || (0<this.day && this.day<32)? "ontario-input ontario-input--2-char-width" :"ontario-input ontario-input--2-char-width ontario-input__error"}`}
                    id="day"
                    type="text"
                    key={'fdIpt_day' + field.Id}
                    maxLength={2}
                    max={31}
                    value={this.day}
                    aria-required={field.Optional!=="Y"}
                    aria-describedby={`${field.LoadBindName}-${field.Id}`}
                    onBlur={this.onBlur}
                    onChange={(e) => this.onODSDateChangeOnDialog(e, "dd")}
                  ></input>
                </div>
              </div>
            </fieldset>
        );

      } else {
        let date;
        if (field.Value) {
          date = new Date(field.Value).toLocaleString();
        }
        if (date == "Invalid Date") {
          date = null;
        }
        controlArray.push(
          <div className='pdf-two-column'>
            <div>{title}</div>
            <div className={classNames({ 'invalid-field--highlighted': (field.Value == '' || field.Value == null) && requiredField })} >{field.Value ? date : null}</div>
          </div>
        );
      }
    }

    return controlArray;

  }

}